// Number and time formatting shared by the tabs (Tallinn time, real minus signs, tabular numbers).
import { formatRelative, formatTallinnTime, tallinnParts } from './tallinn_time';

export const MINUS = '−';
export const hhmm = formatTallinnTime;

// 1 decimal with a real minus sign.
export function num1(v: number): string {
  const s = Math.abs(v).toFixed(1);
  return v < 0 && s !== '0.0' ? `${MINUS}${s}` : s;
}

export const dayKey = (ts: number) => {
  const p = tallinnParts(ts);
  return `${p.year}-${p.month}-${p.day}`;
};

export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// "Tue 14:20"; with the date: "Tue 13 Jan 14:20".
export function weekdayTime(ts: number, withDate = false): string {
  const p = tallinnParts(ts);
  return `${p.weekday}${withDate ? ` ${p.day} ${MONTHS[p.month - 1]}` : ''} ${hhmm(ts)}`;
}

// formatRelative, with seconds under a minute ("40 s ago") for states that update every few seconds.
export function formatAge(ts: number, now: number): string {
  const s = Math.round((now - ts) / 1000);
  return s < 60 ? `${Math.max(0, s)} s ago` : formatRelative(ts, now);
}

export const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
